import {Action, ThunkAction} from '@reduxjs/toolkit';
import {connectRouter, routerMiddleware} from 'connected-react-router'
import {applyMiddleware, combineReducers, compose, createStore} from 'redux'
import userReducer from './UserSlice'
import {reducers} from '../../configuration/reducers';
import thunk from "redux-thunk";
import {createBrowserHistory} from "history";

export const history = createBrowserHistory()

const appReducer = combineReducers({
    router: connectRouter(history),
    user: userReducer,
    ...reducers
})

const rootReducer = (state:any, action:any) => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === 'users/logout/fulfilled') {
        console.log('State cleared')
        state = {  }
    }  
    return appReducer(state, action);
};

export default function configureStore(initialState?: any) {
    return createStore(
        rootReducer,
        initialState,
        compose(
            applyMiddleware(
                routerMiddleware(history)
            ),
            applyMiddleware(thunk)
        ),
    )
}

export const store = configureStore();

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    RootState,
    unknown,
    Action<string>>;
